import React from "react";
import { Css, GitHub, Html, Javascript } from "../../../assets";
import "./index.css";
import { ProfileCardComp } from "../../../component";
import Textdivcomp from "../OurServices/Textdivcomp";
import MsgIcon from "../../../assets/images/MsgIcon.svg";
import fahad from "../../../assets/images/Fahad_Pic.jpg";
import yasirImg from "../../../assets/images/yasir.png";

export default function Whoisbehind() {
  return (
    <div className="Whoisbehind">
      <div className="WhoisbehindTxtdiv">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          className="contentText">
          <p className="text1" style={{ color: "black" }}>OUR CURRICULUM</p>
          <p className="text2" style={{ color: "black", fontWeight: "bold" }}>Built on industry tools</p>
          <p className="text3" style={{ color: "black" }}>
            We teach the technologies that power the modern web — from HTML and CSS to JavaScript and GitHub.
          </p>
        </div>
        <div
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          className="WhoisbehindIconDiv"
        >
          <div className="course_Div">
            <img src={Html} alt="HTML" title="HTML" className="LogoStyles" />
          </div>
          <div className="course_Div">
            <img src={Css} alt="CSS" title="CSS" className="LogoStyles" />
          </div>
          <div className="course_Div">
            <img src={Javascript} alt="JavaScript" title="JavaScript" className="LogoStyles" />
          </div>
          <div className="course_Div">
            <img src={GitHub} alt="GitHub" title="GitHub" className="LogoStyles" />
          </div>
        </div>
      </div>
      <div className="ProfileDiv">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          className="profile-div-responsive" style={{ display: "flex", flexWrap: "wrap", alignSelf: "flex-end", position: "relative" }}>
          <ProfileCardComp pic={fahad} name={"Fahad Zahid"} work={"React Developer at Musketeers Technologies"} discription={"Meet Fahad Zahid! He is one of our best students and was with us at the start of Ayan Tech. Currently, he is working at a multinational company."} />
          <ProfileCardComp pic={yasirImg} name={"Yasir Sheikh"} work={"React Native Developer at HNH Tech"} discription={"Meet Yasir! He was a 10th-grade student. He proved that you don't need a high level of education to become a professional developer and secure an ideal job."} />
        </div>
        <Textdivcomp
          data_aos="fade-left"
          Heading="10,000 people"
          body={"Join thousands of learners who have leveled up their careers and landed developer jobs with Ayan Tech."}
          btnimg={MsgIcon} btntext={"More stories"} top={30} colors={"black"} />
      </div>
    </div>
  );
}
